import { hcpAPI } from 'configs/axios';

export const fetchRecording = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/recordings/${id}`,
    method: 'GET',
    config: { signal },
  });
};
